import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';

interface Datalist {
  label: string;
  value: string;
}

@Component({
  standalone: false,
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.css'],
})
export class InputComponent {
  @Input() required: boolean;
  @Input() type: 'text' | 'number' | 'password' | 'email' | 'date' | 'search' | 'search-browser' | 'search-expression' | 'search-filter';
  @Input() name: string;
  @Input() tab = 1;
  @Input() note: string;
  @Input() info: string;
  @Input() placeholder = '';
  @Input() for = '';
  @Input() label = '';
  @Input() autocomplete = 'on';
  @Input() maxlength: any;
  @Input() smallSelect = false;
  @Input() control = new FormControl();
  @Input() focusout: (event: FocusEvent) => void;
  @Input() datalist?: Datalist[];
  @Output() clearFilterEvent: EventEmitter<string> = new EventEmitter<string>();
  passwordVisible: boolean = false;

  onFocusOut(event: FocusEvent): void {
    if (this.focusout) {
      this.focusout(event);
    }
  }

  togglePasswordVisibility() {
    this.passwordVisible = !this.passwordVisible;
  }

  clearFilter() {
    this.control.setValue('');
    if (this.clearFilterEvent) {
      this.clearFilterEvent.emit();
    }
  }

  selectValue(event: any, value: string) {
    event.preventDefault();
    this.control.setValue(value);
  }
}
